/**
 * Whether a client counts toward the book — the client count and monthly
 * revenue. Prospects have not signed and churned clients have left, so neither
 * is revenue the business has, whatever MonthlyRevenue still says. They stay
 * on the client list; they are left out of its totals. The API's /am/summary
 * applies the same rule (its Book CTE), so the hub card and this page agree.
 */
export const NOT_IN_BOOK = ['Prospect', 'Churned'] as const;

export const inBook = (status: string | null | undefined) =>
  !(NOT_IN_BOOK as readonly string[]).includes(status ?? '');
